/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIContactAddress
 */
export interface APIContactAddress {
    /**
     * 
     * @type {string}
     * @memberof APIContactAddress
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof APIContactAddress
     */
    address1?: string;
    /**
     * 
     * @type {string}
     * @memberof APIContactAddress
     */
    address2?: string;
    /**
     * 
     * @type {string}
     * @memberof APIContactAddress
     */
    address3?: string;
    /**
     * 
     * @type {string}
     * @memberof APIContactAddress
     */
    zipCode?: string;
    /**
     * 
     * @type {string}
     * @memberof APIContactAddress
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof APIContactAddress
     */
    country?: string;
}

/**
 * Check if a given object implements the APIContactAddress interface.
 */
export function instanceOfAPIContactAddress(value: object): value is APIContactAddress {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function APIContactAddressFromJSON(json: any): APIContactAddress {
    return APIContactAddressFromJSONTyped(json, false);
}

export function APIContactAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIContactAddress {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'address1': json['address_1'] == null ? undefined : json['address_1'],
        'address2': json['address_2'] == null ? undefined : json['address_2'],
        'address3': json['address_3'] == null ? undefined : json['address_3'],
        'zipCode': json['zip_code'] == null ? undefined : json['zip_code'],
        'city': json['city'] == null ? undefined : json['city'],
        'country': json['country'] == null ? undefined : json['country'],
    };
}

export function APIContactAddressToJSON(value?: APIContactAddress | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'address_1': value['address1'],
        'address_2': value['address2'],
        'address_3': value['address3'],
        'zip_code': value['zipCode'],
        'city': value['city'],
        'country': value['country'],
    };
}

